module.exports = require("@visa/vds-react/badge-styled");